import { DqApiError } from "./api/types";

const KNOWN = new Set([
  "forbidden",
  "lead_locked",
  "not_found",
  "invalid_pair",
  "invalid_field",
  "invalid_phone",
  "phone_taken",
  "unhandled_reference",
  "both_active_subscriptions", // GAVION import duplicates (88_)
  "paid_commission_lines",
  "invalid_email", // GAVION suspect emails (89_)
]);
/** GAVION commissions: a merge refused because the merged-away lead has a subscription or commission lines. */
const COMMISSION_TABLES = new Set([
  "public.subscriptions",
  "public.commission_statement_lines",
]);

/** i18n key + args of a data-quality error (unknown codes and non-API errors map to `unknown`). */
export const dqErrorMessage = (
  e: unknown,
): [key: string, args: Record<string, unknown>] => {
  const code =
    e instanceof DqApiError && KNOWN.has(e.code) ? e.code : "unknown";
  const detail = (e as DqApiError).detail ?? "";
  if (code === "unhandled_reference" && COMMISSION_TABLES.has(detail))
    return ["gavion.data_quality.errors.unhandled_reference_subscription", {}];
  return [
    `gavion.data_quality.errors.${code}`,
    code === "phone_taken"
      ? { id: detail || "?" }
      : code === "unhandled_reference"
        ? { table: detail.replace(/^public\./, "") || "?" }
        : {},
  ];
};

export const DQ_QUERY_KEY = ["gavion", "data-quality"] as const;
